// src/hooks/transportations/useForceDeleteTransportation.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { forceDeleteTransportation } from "../../api/apiTransportations";
import parseError from "../../utils/parseError";

const useForceDeleteTransportation = () => {
    const queryClient = useQueryClient();

    const {
        mutate: forceDeleteTransportationMutate,
        isPending,
        isLoading,
    } = useMutation({
        mutationFn: forceDeleteTransportation,
        onSuccess: (response) => {
            toast.success(response.message);
            queryClient.invalidateQueries({ queryKey: ["transportations"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to permanently delete transportation");
        },
    });

    return {
        forceDeleteTransportation: forceDeleteTransportationMutate,
        isForceDelete: isPending || isLoading,
    };
};

export default useForceDeleteTransportation;
